import { render, staticRenderFns } from "./MultipleSelect.vue?vue&type=template&id=ed7738a8&"
import script from "./MultipleSelect.vue?vue&type=script&lang=ts&"
export * from "./MultipleSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports